module.exports = __webpack_public_path__ + "static/media/resource-6.cc458d1f.jpg";